<template>
  <div>

    <div
      class="columns is-multiline"
      v-for="(validatorItem, index) in formValidator.validators"
      style="border-bottom: 1px solid #dbdbdb;
    padding-bottom: 12px;"
    >
      <div class="column is-6">
        <b-field label="Validate method">
          <b-select
            placeholder="Select the validate method"
            expanded
            v-model="validatorItem.validator"
            required
          >
            <option
              v-for="validator in validators"
              v-if="isAvailableValidator(formTestMethod.testMethod.alias, validator)"
              :value="validator"
              :key="validator.alias">
              {{ validator.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div v-if="validatorItem.config" class="column is-6" v-for="validatorConfig in validatorItem.validator.validatorConfig">

        <b-field :label="validatorConfig.name" v-if="validatorConfig.type==='select'" :message="validatorConfig.description">
          <b-select expanded v-model="validatorItem.config[validatorConfig.key]" :required="validatorConfig.required">
            <option
              v-for="(value, key) in validatorConfig.options"
              :value="key"
              :key="key">
              {{ value }}
            </option>
          </b-select>
        </b-field>

        <b-field v-else :label="validatorConfig.name" :message="validatorConfig.description">
          <b-input
            v-model="validatorItem.config[validatorConfig.key]"
            :required="validatorConfig.required">
          </b-input>
        </b-field>

      </div>

      <div class="column is-12">
        <b-button size="is-small"
                  @click="removeValidator(index)"
                  icon-left="trash-alt">
          Delete
        </b-button>
      </div>
      <hr>
    </div>
    <br>
    <b-button icon-left="plus" @click="addValidator">
      Add validator
    </b-button>
  </div>
</template>

<script>

import ValidatorService from "@/services/ValidatorService";
import isAvailableValidator from "@/mixins/isAvailableValidator";

export default {
  name: 'Validator',
  mixins: [isAvailableValidator],
  data () {
    return {
      formValidator: {},
      formTestMethod: {},
      validators: [],
    }
  },

  components: {

  },

  created() {
    this.getValidators();
    this.formValidator = this.$store.getters['testType/formValidator'];
    this.formTestMethod = this.$store.getters['testType/formTestMethod'];
  },

  methods: {
    getValidators() {
      ValidatorService.getList()
        .then(response => {
          this.validators = response.data
        })
    },
    addValidator() {
      this.$store.dispatch('testType/addValidator')
    },

    removeValidator(index) {
      this.$store.dispatch('testType/removeValidator', index)
    }
  }
}
</script>
